<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import MetaBusinessAgentAPI from 'dashboard/api/metaBusinessAgent';

import Button from 'dashboard/components-next/button/Button.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  hookId: { type: [String, Number], required: true },
});

const { t } = useI18n();
const T = key => t(`INTEGRATION_SETTINGS.META_BUSINESS_AGENT.TEST.${key}`);

const message = ref('');
const conversationId = ref(null);
const isSending = ref(false);
const messages = ref([]);

const send = async () => {
  if (!message.value.trim()) return;
  const userMsg = message.value;
  messages.value.push({ from: 'user', text: userMsg });
  message.value = '';
  isSending.value = true;
  try {
    const { data } = await MetaBusinessAgentAPI.runAgentTest(props.hookId, {
      user_msg: userMsg,
      conversation_id: conversationId.value,
    });
    conversationId.value = data.conversation_id;
    messages.value.push({ from: 'agent', text: data.agent_response });
  } catch (error) {
    useAlert(T('API.ERROR'));
  } finally {
    isSending.value = false;
  }
};
</script>

<template>
  <div class="flex flex-col gap-4 max-w-2xl">
    <p class="text-sm text-n-slate-11">{{ T('DESCRIPTION') }}</p>
    <div class="flex flex-col gap-2 min-h-[10rem]">
      <p v-if="!messages.length" class="text-n-slate-11 text-sm">
        {{ T('EMPTY_STATE') }}
      </p>
      <div
        v-for="(entry, index) in messages"
        :key="index"
        class="p-3 rounded-lg max-w-[80%]"
        :class="
          entry.from === 'user'
            ? 'self-end bg-n-brand/10 text-n-slate-12'
            : 'self-start bg-n-alpha-1 text-n-slate-12'
        "
      >
        {{ entry.text }}
      </div>
    </div>
    <div class="flex gap-2">
      <Input
        v-model="message"
        class="flex-1"
        :placeholder="T('PLACEHOLDER')"
        @keyup.enter="send"
      />
      <Button :label="T('SEND_BUTTON')" :is-loading="isSending" @click="send" />
    </div>
  </div>
</template>
